
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { BatchUpdateItem } from 'types'
import { useSyncQueryCache } from '../organizations_table/useSyncQueryCache'

const batchUpdateTaskItems = async (updates: BatchUpdateItem[]) => {
  const url = `${baseUrl}/aws/tasks/updatebatch`
  const response = await axios.put(url, { tasks: updates })

  if (response.status !== 200) {
    throw new Error('Batch update failed')
  }

  return response.data
}

export const useBatchUpdateTaskItems = () => {
  const queryClient = useQueryClient()
  const { syncTaskFieldsAfterBatchUpdate } = useSyncQueryCache()

  return useMutation({
    mutationFn: batchUpdateTaskItems,
    onMutate: async variables => {
      // Optimistically update the tasks cache
      await queryClient.cancelQueries({ queryKey: ['tasks_table'] })
      const previousTasks = queryClient.getQueryData(['tasks_table'])

      // Apply optimistic field updates
      if (Array.isArray(variables)) {
        syncTaskFieldsAfterBatchUpdate(queryClient, variables as any)
      }

      return { previousTasks }
    },
    onSuccess: (_data, variables) => {
      console.log('[BatchUpdateTaskItems] Success, syncing cache...')

      // Re-sync to ensure server state is reflected
      if (Array.isArray(variables)) {
        syncTaskFieldsAfterBatchUpdate(queryClient, variables as any)
      }
    },
    onError: (error, _variables, context) => {
      // Rollback on error
      if (context?.previousTasks) {
        queryClient.setQueryData(['tasks_table'], context.previousTasks)
      }
      console.error('[BatchUpdateTaskItems] Error:', error)
    },
  })
}
